import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <main style={{ maxWidth: 480, margin: "120px auto", padding: 32, textAlign: "center" }}>
      <p
        style={{
          fontFamily: "var(--font-mono)",
          fontSize: 12,
          color: "var(--mute)",
          marginBottom: 16,
        }}
      >
        404
      </p>
      <h1 style={{ fontSize: 32, fontWeight: 600, margin: "0 0 12px" }}>Page not found</h1>
      <p style={{ color: "var(--body)", lineHeight: 1.6 }}>
        That URL doesn't match anything in this workspace.{" "}
        <Link to="/" style={{ color: "var(--ink)", textDecoration: "underline" }}>
          Back home
        </Link>
        .
      </p>
    </main>
  );
}
